package common.animation

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 17.08.23
 * Author : marcusspors
 */
data class Transition<STATE>(
 val mDelay: Long,
 val mDuration: Long,
 val mData: STATE,
 val mNextState: Int? = null
)
